<template>
  <div>
    <Heading
      v-if="headline.text"
      :tag="headline?.tag ?? 'h2'"
      color="blue"
    >
      {{ headline.text }}
    </Heading>
    <p v-if="subline" class="mt-4">{{ subline }}</p>
    <EditableArea :content="main" :custom-view="ImageTilesComponentArea" class="mt-8" />
  </div>
</template>

<script setup>
import { EditableArea } from "@magnolia/vue-editor";
import ImageTilesComponentArea from "~/templates/components/cms/ImageTilesComponentArea.vue";
import { Heading } from "~/components/clarity-ui/Heading";

defineProps(["headline", "subline", "main"]);
</script>
